<template>
<div id="home" class= "container main">
    
    
  
    <h2 class="emphaticsubtitle">
     Are you looking for a Website Developer??
    </h2>

    <p style="margin-top: 2%;">
      Want to get your company online?? If YES!, You came to right palce. I can make Websites, Blogs and setup Social Media Environment.
     </p>
     
    <p>
        I also, have knowledge of software testing and if you are looking for a <strong>Software Tester</strong>.. I might help you.
        <br>
        I can do following Testings of your Web APP:
        <ul>
            <li>Functional Testing</li>
            <li>Performance Testing</li>
            <li>Smoke Testing</li>
            <li>Integration Testing</li>
            <li>Globalization Testing</li>
            <li>Compatibility Testing</li>
            <li>System Testing</li>
        </ul>
         
     </p>

     <section class="centeredmessage">
         <h2 class="emphaticsubtitle"><strong>Technologies</strong></h2>
         <div class="row" style="margin-top: 2%">
              
             <div class="col-sm">
                 <i class="fa fa-html5 fa-4x" style="color:#EA2F07" aria-hidden="true"></i>
             </div>
             &nbsp;
             <div class="col-sm">
                <i class="fa fa-css3 fa-4x" style="color: #0756EA" aria-hidden="true"></i>
             </div>
             &nbsp;
             <div class="col-sm">
                 <i class="fab fa-js fa-4x"></i>
             </div>
             &nbsp;
             <div class="col-sm">
                 <i class="fab fa-node-js fa-4x" style="color: #006C14"></i>
             </div>
             &nbsp;
             <div class="col-sm">
                 <i class="fab fa-vuejs fa-4x" style="color: #6AC31E"></i>
             </div>
             
             
         </div>
     </section>

    <h3 class="centeredmessage">
      I can help you with your Web Project or Software Testing Project. 
    </h3>
    <p class="centeredmessage">How may I help you? <router-link to="/contact">Drop me an email</router-link> describing your project. I will reply as soon as possible.</p>

    
</div>
  



</template>

<script>
export default {
  name: 'home',
    data (){
        return {
            
        }
    }
}
</script>

<style scoped>
.main {
  padding-left: 12%;
  padding-right: 12%;
}

.subtitle2 {
  margin-top: 1%;
}

.emphaticsubtitle {
  font-family: 'Overlock', cursive;
  font-style: italic;
  text-align: center;
  
}

.centeredmessage {
  text-align: center;
  margin-bottom: 3%;
}

p{
    font-family: cursive;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue